import type { IAdminHeaderTopLayoutProps } from '@framework/theme/src/admin/AdminHeaderTopLayout';
import {
  AdminHeaderTopRowLayout,
  AdminHeaderTopWrapperLayout,
  FlexRow,
} from '@framework/ui';
import { TopNextgenerationeuLogo } from '../common/TopNextgenerationeuLogo';

/**
 * Fascia in alto della pagina di amministrazione.
 */
export function AdminHeaderTopLayout(props: IAdminHeaderTopLayoutProps) {
  const { fixed, right: exRight, ...rest } = props;

  // per mostrare il logo NextGenerationEU a destra
  const right = (
    <FlexRow gutter={24} left={<TopNextgenerationeuLogo />}>
      {exRight}
    </FlexRow>
  );

  return (
    <AdminHeaderTopWrapperLayout fixed={fixed}>
      <AdminHeaderTopRowLayout {...rest} right={exRight} />
    </AdminHeaderTopWrapperLayout>
  );
}
